<template>
  <article class="pay_options_page">
    <header class="pages_title"><h3>选择支付方式</h3></header>
    <section class="pay_options_container">
      <div class="payment_amount">
        <span class="remaining_payment_time gray_color">支付剩余时间{{ currentDisplayTimeout }}</span>
        <p class="amount_content">
          <i class="iconfont icon-renminbi"></i>
          <span class="amount">{{ orderData.TotalPrice }}</span>
        </p>
        <span class="payee gray_color">收款方信息:{{ orderType == 1 ? '中山城市候机楼票务有限公司' : '中山市旅游集散中心' }}</span>
      </div>

      <ul class="pay_list_wrap">
        <template v-for="(payItem, key, index) in paymentList">
          <li :key="key" class="pay_list_item" @click="choosePayStyle(payItem)">
            <label class="pay_select_icon">
              <p class="pay_item flex_wrap a_i_center">
                <i :class="payItem.iconCls"></i>
                <span class="">
                  {{ payItem.PayStyle }}
                  <strong class="ghyouhui red-text" v-if="payItem.Description != ''">{{ payItem.Description }}</strong>
                </span>
              </p>
              <i :class="payItem.isChoose ? 'iconfont icon-xuanze' : 'iconfont icon-xuanzel'"></i>
              <input type="radio" />
            </label>
          </li>
        </template>
      </ul>
    </section>
    <footer class="btn_wrap big-btn"><button class="btn confirm_pay_btn" :disabled="!isOKtoPay" @click="payOrder">确认支付</button></footer>

    <transition name="tanchu" mode="out-in">
      <article v-show="isShowQRCode" class="mask_wrap" @click.self="showHideMask">
        <transition name="scale_up" mode="out-in">
          <section v-show="isShowQRCode" class="mask_container_wrap qr_code">
            <p><span>长按识别二维码，选择工行e支付用工行信用卡付款，可享满减优惠.</span></p>
            <div class="mask_article_wrap" id="qrcode"></div>
          </section>
        </transition>
      </article>
    </transition>
  </article>
</template>

<script>
import orderApi from '../request/orderApi';
import paymentApi from '../request/paymentApi';
import baseTool from '../utils/baseFunction';
import QRCode from '../utils/qrcode.min';
export default {
  name: 'PaymentSelector',
  data() {
    return {
      paymentList: [
        {
          PayStyle: '微信支付',
          Description: '',
          method: 'wechatPay',
          iconCls: 'iconfont icon-weixinzhifu1 wx_color',
          isChoose: true
        },
        {
          PayStyle: '工行e支付',
          Description: '',
          method: 'icbcQRCodePay',
          iconCls: 'iconfont icon-gonghang red-text',
          isChosoe: false
        }
      ],
      orderData: {},
      orderId: '',
      paymentMethod: '',
      isShowQRCode: false,
      qrcode: {},
      orderType: null,
      checkPayStateTimer: null,
      counterTimer: null,
      counterTimeSpan: 1000,
      currentDisplayTimeout: ''
    };
  },
  activated() {
    this.$Spin.show();
    this.orderId = this.$route.params.id;
    this.orderType = this.$route.params.type;
    this.getOrderData();
    this.paymentList = [
      {
        PayStyle: '微信支付',
        Description: '',
        method: 'wechatPay',
        iconCls: 'iconfont icon-weixinzhifu1 wx_color',
        isChoose: true
      },
      {
        PayStyle: '工行e支付',
        Description: '',
        method: 'icbcQRCodePay',
        iconCls: 'iconfont icon-gonghang red-text',
        isChosoe: false
      }
    ];
    this.qrcode = new QRCode('qrcode', {
      text: '',
      width: 256,
      height: 256,
      colorDark: '#000000',
      colorLight: '#ffffff',
      correctLevel: QRCode.CorrectLevel.H
    });
  },
  destroyed() {
    if (this.checkPayStateTimer) clearInterval(this.checkPayStateTimer);
    if (this.counterTimer) clearInterval(this.counterTimer);
  },
  methods: {
    getOrderData() {
      let that = this;
      if (this.orderType == 1) {
        orderApi.getTicketOrderInfo(this.$store.state.user.OpenId, this.orderId).then(sucRes => {
          if (sucRes.success) {
            that.orderData = sucRes.data;
            if (that.orderData.OrderType == 4) {
              that.paymentList = [
                {
                  PayStyle: '微信支付',
                  Description: '',
                  method: 'wechatPay',
                  iconCls: 'iconfont icon-weixinzhifu1 wx_color',
                  isChoose: true
                }
              ];
            }
            that.$Spin.hide();
            that.startCount();
          }
        });
      } else if (this.orderType == 2) {
        orderApi.getScopetOrderInfo(this.$store.state.user.OpenId, this.orderId).then(sucRes => {
          if (sucRes.success) {
            that.orderData = sucRes.data;
          }
          that.$Spin.hide();
          that.startCount();
        });
      }
    },
    startCount() {
      let that = this;
      this.counterTimer = setInterval(function() {
        let addMin = that.orderType == 1 ? 10 : 30;
        let nowDate = new Date();
        let orderDate = new Date(that.orderData.CreateDate);
        let min = orderDate.getMinutes();
        orderDate.setMinutes(min + addMin);
        let TimeSpan = orderDate.getTime() - nowDate.getTime();
        if (TimeSpan > 0) {
          let leave1 = TimeSpan % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
          let hours = Math.floor(leave1 / (3600 * 1000));
          //计算相差分钟数
          let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
          let minutes = Math.floor(leave2 / (60 * 1000));
          //计算相差秒数
          let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
          let seconds = Math.round(leave3 / 1000);
          that.currentDisplayTimeout = minutes + '分钟' + seconds + '秒后订单超时';
        } else that.currentDisplayTimeout = '已超时，请重新下单。';
      }, this.counterTimeSpan);
    },
    wechatPay() {
      let that = this;
      //			this.$Spin = this.$loading.show();
      //			let url = "icbcpayment.aspx?openid=" + OpenId + "&id=" + this.orderData.ID + "&type=" + BusinessID + "&redirectUri=" + window.location.href.split('#')[0];
      //			if(this.orderData.OrderType == 4) {
      //				url = "IcbcCarOrderPayment.aspx?openid=" + OpenId + "&id=" + this.orderData.ID + "&type=" + BusinessID + "&redirectUri=https://www.callmefix.net/wechat/zsyuntu.aspx";
      //			}
      //			window.location.href = url;

      // if (MiniOpenId != '' && MiniOpenId) {
      //   let url = '../webpayprocess/webpayprocess?ordertype=0&id=' + that.orderId + '&businessid=' + BusinessID;
      //   wx.miniProgram.navigateTo({
      //     url: url
      //   });
      // } else {
      if (this.orderType == 1) {
        // 车票，跳转支付。
        let url =
          '//www.callmefix.net/wechat/icbcpayment.aspx?openid=' +
          this.$store.state.user.OpenId +
          '&id=' +
          this.orderData.ID +
          '&type=1&redirectUri=' +
          window.location.href.split('#')[0];
        window.location.href = url;
      } else {
        // 业务订单，直接微信接口支付。
        let url =
          '//www.callmefix.net/wechat/icbcpayment.aspx?openid=' +
          this.$store.state.user.OpenId +
          '&id=' +
          this.orderData.ID +
          '&type=2&redirectUri=' +
          window.location.href.split('#')[0];
        window.location.href = url;
        //					this.$http.get(host + 'Payment/getWeChatPayParamsV2', {
        //							params: {
        //								openid: OpenId,
        //								id: this.orderData.ID,
        //								type: this.orderData.BusinessID,
        //								ordertype: 1
        //							}
        //						}).then(function(response) {
        //							console.log(response.body.data.signType);
        //							console.log(response.body.data.timeStamp);
        //							console.log(response.body.data.nonceStr);
        //							console.log(response.body.data.package);
        //							console.log(response.body.data.paySign);
        //							if(response.body.success) {
        //								wx.chooseWXPay({
        //									timestamp: response.body.data.timeStamp,
        //									nonceStr: response.body.data.nonceStr,
        //									package: response.body.data.package,
        //									signType: response.body.data.signType,
        //									paySign: response.body.data.paySign,
        //									success: function(res) {
        //										that.$Message.success('支付成功！');
        //										that.$router.replace({
        //											name: 'myorderlist'
        //										});
        //									},
        //									fail: function(fail) {
        //										that.$Message.warning('支付失败！');
        //										that.$router.replace({
        //											name: 'myorderlist'
        //										});
        //									}
        //								});
        //							} else {
        //								that.$Message.error(response.body.message);
        //							}
        //							that.$Spin.hide();
        //						}),
        //						function(fail) {
        //							console.log(fail);
        //							this.$Spin.hide();
        //						};
      }
      // }
    },
    checkPayState() {
      let that = this;
      paymentApi.checkPayState(this.$store.state.user.OpenId, this.orderId, this.orderType).then(sucRes => {
        if (sucRes.success) {
          if (sucRes.data) {
            that.$Message.success('支付成功！');
            clearInterval(that.checkPayStateTimer);
            that.$router.replace({
              name: 'MainIndexPage',
              params: {
                page: 'myorder'
              }
            });
          }
        }
      });
    },
    icbcQRCodePay() {
      let that = this;
      this.$Spin.show();
      paymentApi.getIcbcPayQRcode(this.$store.state.user.OpenId, this.orderId, this.orderType).then(sucRes => {
        if (sucRes.success && sucRes.data) {
          that.isShowQRCode = true;
          that.checkPayStateTimer = setInterval(function() {
            that.checkPayState();
          }, 2000);
          that.qrcode.clear();
          that.qrcode.makeCode(sucRes.data);
          let qrcodeEle = document.getElementById('qrcode');
          let myCanvas = document.getElementsByTagName('canvas')[0];
          let img = baseTool.convertCanvasToImage(myCanvas);
          qrcodeEle.append(img);
        }
        that.$Spin.hide();
        let qrcodeEle = document.getElementById('qrcode');
        let img1 = qrcodeEle.getElementsByTagName('img')[0];
        if (img1) {
          qrcodeEle.removeChild(img1);
        }
      });
    },
    choosePayStyle(payItem) {
      this.paymentMethod = payItem.method;
      for (let i = 0; i < this.paymentList.length; i++) {
        if (this.paymentList[i].PayStyle == payItem.PayStyle) {
          this.paymentList[i].isChoose = true;
        } else {
          this.paymentList[i].isChoose = false;
        }
      }
    },
    payOrder() {
      let tmp = null;
      for (let i = 0; i < this.paymentList.length; i++) {
        if (this.paymentList[i].isChoose) {
          tmp = this.paymentList[i];
          break;
        }
      }
      if (tmp && tmp.PayStyle == '微信支付') {
        this.wechatPay();
      } else {
        this.icbcQRCodePay();
      }
    },
    showHideMask() {
      this.isShowQRCode = !this.isShowQRCode;
      if (!this.isShowQRCode) {
        clearInterval(this.checkPayStateTimer);
      }
    }
  },
  computed: {
    lastTime() {
      let addMin = this.orderType == 1 ? 10 : 30;
      let nowDate = new Date();
      let orderDate = new Date(this.orderData.CreateDate);
      let min = orderDate.getMinutes();
      orderDate.setMinutes(min + addMin);
      let TimeSpan = orderDate.getTime() - nowDate.getTime();
      if (TimeSpan > 0) {
        let leave1 = TimeSpan % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
        let hours = Math.floor(leave1 / (3600 * 1000));
        //计算相差分钟数
        let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
        let minutes = Math.floor(leave2 / (60 * 1000));
        //计算相差秒数
        let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
        let seconds = Math.round(leave3 / 1000);
        return minutes + '分钟' + seconds + '秒后订单超时';
      } else return '已超时，请重新下单。';
    },
    isOKtoPay() {
      let value = false;
      for (let i = 0; i < this.paymentList.length; i++) {
        if (this.paymentList[i].isChoose) {
          return true;
        }
      }
      return false;
    }
  }
};
</script>

<style scoped lang="less">
@import '../style/public';

.pay_options_container {
  overflow: hidden;
  .flex_wrap(initial, initial, initial, column);
}
.pay_select_icon {
  line-height: 8vh;
  .flex_wrap(space-between, center);
}
.pay_select_icon > .iconfont {
  /*margin: 0 .5em 0 0;*/
}
.payment_amount {
  padding: 1.5em 0;
  .flex_wrap(center, center, initial, column);
}
.payment_amount > span {
  text-align: center;
}
.payment_amount .iconfont.icon-renminbi {
  margin: 0 0.2em 0 0;
  font-size: 0.4rem;
}
.pay_item {
  .flex_wrap(initial);
}
.pay_item .iconfont {
  font-size: 0.6rem;
  /*padding-top: 4px;*/
  margin: 0 0.4em 0 0;
}
.pay_list_wrap {
  flex: 1;
  overflow: auto;
  border-top: 1px solid #ddd;
}
.pay_list_item {
  border-bottom: 1px solid #ddd;
  padding: 0 1em;
}
.pay_list_item label {
}
.pay_list_item .iconfont.icon-xuanze1 {
  color: #888;
}
.remaining_payment_time,
.payee {
  width: 90%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: clip;
}
.payment_amount .amount {
  font-size: 0.6rem !important;
  font-weight: 600;
}
.big-btn {
  margin: 1em 0;
}

.mask_wrap {
  z-index: 999;

  .qr_code {
    max-height: 9.5rem;
    text-align: center;
    p {
      padding: 0 0.6rem;
      text-align: left;
      margin-bottom: 0.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PaymentSelector.vue